import { highlight } from "prismjs";

export default {
  prod_P2ifYcgHeS61f8: {
      name: 'descriptions.meteredName',
      description: 'descriptions.metered',
      marketingFeatures: ['marketingFeatures.unlimitedPerMo', 'marketingFeatures.unlimitedConcurrency'],
      features: [
        { text: 'features.forum', enabled: true, highlight: true },
        { text: 'features.api', enabled: true, highlight: true },
        { text: 'features.alerts', enabled: true, highlight: true },
        { text: 'features.subhourly', enabled: true, highlight: true},
        { text: 'features.conditions', enabled: true },
        { text: 'features.geocoding', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkonly', enabled: true },
        { text: 'features.commercialuse', enabled: true },
        { text: 'features.history', enabled: true },
        { text: 'features.forecast', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.weathermapapi', enabled: true },
        

      ],
    },
   
    prod_P2iEHuaJlboQ6r: {
      name: 'descriptions.professionalName',
      description: 'descriptions.professional',
      marketingFeatures: ['marketingFeatures.tenMPerMo', 'marketingFeatures.singleConcurrency'],
      features: [
        { text: 'features.history', enabled: true , highlight: true},
        { text: 'features.forecast', enabled: true , highlight: true},
        { text: 'features.coverage', enabled: true , highlight: true},
        { text: 'features.conditions', enabled: true },
        { text: 'features.geocoding', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkschedule', enabled: true },
        { text: 'features.commercialuse', enabled: true },
        { text: 'features.forum', enabled: true },
        { text: 'features.api', enabled: true },
        { text: 'features.weathermapapi', enabled: true },
        { text: 'features.alerts', enabled: true },


      ],
    },
    
    prod_P2if4Ek3zDY54r: {
      name: 'descriptions.corporateName',
      description: 'descriptions.corporate',
      marketingFeatures: ['marketingFeatures.unlimitedPerMo', 'marketingFeatures.teamConcurrency'],
      features: [
        { text: 'features.email', enabled: true, highlight: true  },
        { text: 'features.tenusers', enabled: true , highlight: true },
        { text: 'features.degreedays', enabled: true, highlight: true },
        { text: 'features.extendedelements', enabled: true , highlight: true },
        { text: 'features.noattribution', enabled: true, highlight: true},
        { text: 'features.conditions', enabled: true },
        { text: 'features.geocoding', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkschedule', enabled: true },
        { text: 'features.commercialuse', enabled: true },
        { text: 'features.history', enabled: true },
        { text: 'features.forecast', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.api', enabled: true },
        { text: 'features.weathermapapi', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.subhourly', enabled: true },
        

      ],
    },
    prod_enterprise: {
      name: 'descriptions.enterpriseName',
      description: 'descriptions.enterprise',
      marketingFeatures: ['marketingFeatures.unlimitedPerMo', 'marketingFeatures.customConcurrency'],
      features: [
        { text: 'features.prioritysupport', enabled: true , highlight: true},
        { text: 'features.unlimitedusers', enabled: true , highlight: true},
        { text: 'features.sla', enabled: true, highlight: true },
        { text: 'features.invoice', enabled: true, highlight: true}, 
        { text: 'features.customterms', enabled: true, highlight: true}, 
        { text: 'features.guaranteedcapacity', enabled: true, highlight: true}, 
        { text: 'features.conditions', enabled: true },
        { text: 'features.geocoding', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkschedule', enabled: true },
        { text: 'features.commercialuse', enabled: true },
        { text: 'features.history', enabled: true },
        { text: 'features.forecast', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.api', enabled: true },
        { text: 'features.weathermapapi', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.subhourly', enabled: true },
        { text: 'features.degreedays', enabled: true },
        { text: 'features.extendedelements', enabled: true  },
        { text: 'features.noattribution', enabled: true },
      
      ],
    },
    prod_llxlevel1: {
      name: 'descriptions.llxlevel1Name',
      description: 'descriptions.llxlevel1',
      marketingFeatures: ['features.qpmolimitllx1', 'features.qpmlimitllx1'],
      features: [
        /*{ text: 'features.qpmlimitllx1', enabled: true , highlight: true},
        { text: 'features.qpmolimitllx1', enabled: true , highlight: true},*/
        { text: 'features.forecast', enabled: true, highlight: true},
        { text: 'features.limitedhistory', enabled: true, highlight: true},
        { text: 'features.min10updates', enabled: true, highlight: true},
        { text: 'features.integratedgeocoding', enabled: true, highlight: true },
        { text: 'features.integratedresult', enabled: true, highlight: true },
        { text: 'features.commercialuse', enabled: true, highlight: true},
        { text: 'features.conditions', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.hourlydays4', enabled: true },
        { text: 'features.minutelyhours3', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.weathermapapi', enabled: true },
        { text: 'features.email', enabled: true },
        { text: 'features.formatsflatjsoncsv', enabled: true },
        { text: 'features.uptime999', enabled: true },
      ],
    },
    prod_llxlevel2: {
      name: 'descriptions.llxlevel2Name',
      description: 'descriptions.llxlevel2',
      marketingFeatures: ['features.qpmolimitllx2', 'features.qpmlimitllx2'],
      features: [
        /*{ text: 'features.qpmlimitllx2', enabled: true , highlight: true},
        { text: 'features.qpmolimitllx2', enabled: true , highlight: true},*/
        { text: 'features.forecast', enabled: true, highlight: true},
        { text: 'features.limitedhistory', enabled: true, highlight: true},
        { text: 'features.min10updates', enabled: true, highlight: true},
        { text: 'features.integratedgeocoding', enabled: true, highlight: true },
        { text: 'features.integratedresult', enabled: true, highlight: true },
        { text: 'features.commercialuse', enabled: true, highlight: true},
        { text: 'features.conditions', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.hourlydays4', enabled: true },
        { text: 'features.minutelyhours3', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.weathermapapi', enabled: true },
        { text: 'features.email', enabled: true },
        { text: 'features.formatsflatjsoncsv', enabled: true },
        { text: 'features.uptime999', enabled: true },

      ],
    },
    prod_llxlevelenterprise: {
      name: 'descriptions.llxEnterpriseName',
      description: 'descriptions.llxEnterprise',
      marketingFeatures: ['features.qpmolimitllxcontactus', 'features.qpmlimitllxcontactus'],
      features: [
        /*{ text: 'features.qpmlimitllxcontactus', enabled: true , highlight: true},
        { text: 'features.qpmolimitllxcontactus', enabled: true , highlight: true},*/
        { text: 'features.forecast', enabled: true, highlight: true},
        { text: 'features.limitedhistory', enabled: true, highlight: true},
        { text: 'features.min10updates', enabled: true, highlight: true},
        { text: 'features.integratedgeocoding', enabled: true, highlight: true },
        { text: 'features.integratedresult', enabled: true, highlight: true },
        { text: 'features.commercialuse', enabled: true, highlight: true},
        { text: 'features.conditions', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.hourlydays4', enabled: true },
        { text: 'features.minutelyhours3', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.weathermapapi', enabled: true },
        { text: 'features.prioritysupport', enabled: true },
        { text: 'features.formatsflatjsoncsv', enabled: true },
        { text: 'features.sla', enabled: true },
      ],
    },
    prod_NJWuAMntHzcYWM: {
      name: 'descriptions.histFcstName',
      description: 'descriptions.histFcst',
      marketingFeatures: [],
      features: [
        { text: 'features.yearsavailable', enabled: true , highlight: true},
        { text: 'features.fullforecast', enabled: true , highlight: true},
        { text: 'features.coverage', enabled: true , highlight: true},
        { text: 'features.customdays', enabled: true , highlight: true},
      ],
    },

    prod_weathermaps: {
      name: 'descriptions.weatherMapsName',
      description: 'descriptions.weatherMaps',
      marketingFeatures: [],
      features: [
        { text: 'features.multiplelayers', enabled: true , highlight: true},
        { text: 'features.radarlayers', enabled: true , highlight: true},
        { text: 'features.preciptotals', enabled: true , highlight: true},
        { text: 'features.easyintegrate', enabled: true , highlight: true},
      ],
    },

    prod_weatherStats: {
      name: 'descriptions.weatherStatsName',
      description: 'descriptions.weatherStats',
      marketingFeatures: [],
      features: [
        { text: 'features.historysummaries', enabled: true, highlight: true },
        { text: 'features.frostdates', enabled: true , highlight: true},
        { text: 'features.customfiltering', enabled: true , highlight: true},
        { text: 'features.areaagg', enabled: true , highlight: true},
      ],
    },
    prod_loadingAccelerator: {
      name: 'descriptions.loadingAcceleratorName',
      description: 'descriptions.loadingAccelerator',
      marketingFeatures: [],
      features: [
        { text: 'features.loaddb', enabled: true , highlight: true},
        { text: 'features.increasedloadlimits', enabled: true , highlight: true},
        { text: 'features.unthrottled', enabled: true , highlight: true},
        { text: 'features.lengthflexible', enabled: true, highlight: true },
      ],
    },
  };
  